"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { CodeBlock as CodeBlockType } from "@/payload-types";
import { cn } from "@/utilities/core/cn";
interface CodeBlockProps {
  block: CodeBlockType;
  className?: string;
}
const LANGUAGE_LABELS: Record<string, string> = {
  typescript: "TypeScript",
  javascript: "JavaScript",
  css: "CSS",
  html: "HTML",
  json: "JSON",
  python: "Python",
  bash: "Bash",
  plaintext: "Plain Text"
};

/**
 * Renders a code block from the article content.
 * Displays code with language label and basic styling.
 */
export function CodeBlock(t0) {
  const $ = _c(11);
  const {
    block,
    className
  } = t0;
  const language = block.language || "plaintext";
  const languageLabel = LANGUAGE_LABELS[language] || language;
  let t1;
  if ($[0] !== className) {
    t1 = cn("mb-6 bg-card overflow-hidden", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== languageLabel) {
    t2 = <div className="bg-muted px-4 py-2 text-xs font-medium text-muted-foreground border-b border-border">{languageLabel}</div>;
    $[2] = languageLabel;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `language-${language} text-foreground`;
  let t4;
  if ($[4] !== block.code || $[5] !== t3) {
    t4 = <pre className="bg-card p-4 m-0! overflow-x-auto text-sm leading-relaxed"><code className={t3}>{block.code}</code></pre>;
    $[4] = block.code;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t4) {
    t5 = <div className={t1}>{t2}{t4}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}